export const PROPERTY_SEPARATOR = '|';
export const DISCRIMINATOR_SEPARATOR = '#';
export const RESPONSE_POSTFIX = '/response';
